import React, { useState, useEffect } from 'react';
import { getApi } from '../services/apiServices';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';

function PrivacyPolicy() {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();
  const [policyData, setPolicyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Language mapping function to convert app language codes to API language codes
  const getApiLanguageCode = (appLanguage) => {
    const languageMap = {
      'ar': 'ar',     // Arabic
      'da': 'da',     // Danish
      'de': 'de',     // German
      'en': 'en',     // English
      'es': 'es',     // Spanish
      'fr': 'fr',     // French
      'he': 'he',     // Hebrew
      'it': 'it',     // Italian
      'ja': 'ja',     // Japanese
      'ko': 'ko',     // Korean
      'nl': 'nl',     // Dutch
      'no': 'no',     // Norwegian
      'pl': 'pl',     // Polish
      'pt': 'pt',     // Portuguese
      'ru': 'ru',     // Russian
      'sv': 'sv',     // Swedish
      'tr': 'tr',     // Turkish
      'zh': 'zh_CN'   // Chinese (Simplified)
    };
    return languageMap[appLanguage] || 'en'; // Default to English if not found
  };

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        setLoading(true);
        const apiLanguage = getApiLanguageCode(currentLanguage);
        const response = await getApi(`/api/privacy-policy?lang=${apiLanguage}`);
        if (response?.status && response?.data) {
          setPolicyData(response.data);
        } else {
          setError('Failed to fetch privacy policy.');
        }
      } catch (err) {
        setError('Failed to fetch privacy policy.');
      } finally {
        setLoading(false);
      }
    };
    fetchPolicy();
  }, [currentLanguage]);

  if (loading) return (
    <div className="loader-overlay">
      <span className="loader"></span>
    </div>
  );
  if (error) return <div>{error}</div>;

  return (
    <>
    <section className="faq  terms-nd-condition">
      <div  className='container'> 
        <h1 className='main-heading'>{t('privacyPolicy.title')}</h1>
        {policyData && Object.entries(policyData).map(([section, items]) => (
          <div key={section}>
            <h2 className='inner-heading'>{section}</h2>
            <ul className='terms-list'>
              {Array.isArray(items) && items.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
    </>
  );
}

export default PrivacyPolicy;
